import { Injectable } from '@angular/core';
import { BullhornDataSourceApiService } from 'datasource-service-lib';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BullhornSettingsService {

  private settingsResponse: any = undefined;
  private readonly leadAndOpportunityEnabledField = 'leadAndOpportunityEnabled';

  private readonly CLIENT_SETTINGS_FIELDS = [
    this.leadAndOpportunityEnabledField
  ];

  constructor(private bullhornDataSourceApiService: BullhornDataSourceApiService) {}

  get settings(): Observable<any> {
    return this.loadClientSettings();
  }

  get clientLeadOpportunityEnabled(): Observable<boolean> {
    return this.loadClientSettings().pipe(
      map((response) => response[this.leadAndOpportunityEnabledField])
    );
  }

  private loadClientSettings(): Observable<any> {
    if (this.settingsResponse) {
      return of(this.settingsResponse);
    }

    return this.bullhornDataSourceApiService.settings(this.CLIENT_SETTINGS_FIELDS.join(',')).pipe(
      map((response) => {
        this.settingsResponse = response;
        return this.settingsResponse;
      }),
      catchError((error) => {
        console.error(error);
        throw error;
      })
    );
  }
}
